import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carousel-create',
  templateUrl: './carousel-create.component.html',
  styleUrls: ['./carousel-create.component.scss']
})
export class CarouselCreateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/carousel/carousel-create/carousel-create.component.ts